import React, { ChangeEvent, useCallback, useMemo } from 'react'
import TextField from '@material-ui/core/TextField'
import { useTranslation } from 'react-i18next'
import Grid from '@material-ui/core/Grid'

export type TextProps = {
  label: string
  value?: string
  columns?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  mdColumns?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  aloneInRow?: boolean
  displayOnly?: boolean
  changeHandler?: (e: string) => void
  multiline?: boolean
  variant?: 'standard' | 'filled' | 'outlined'
  onlyNumbers?: boolean
  required?: boolean
}

export const Text: React.FC<TextProps> = ({
  value,
  required,
  mdColumns,
  changeHandler,
  displayOnly,
  aloneInRow,
  columns,
  label,
  multiline,
  variant,
  onlyNumbers,
}) => {
  const { t } = useTranslation('common')
  const shownLabel = useMemo(() => t(label), [t, label])
  const inputType = useMemo(() => (onlyNumbers ? 'number' : 'text'), [onlyNumbers])

  const onChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      if (!changeHandler) {
        return
      }
      let val = e.target.value as string
      if (onlyNumbers) {
        val = val.replace(',', '.')
      }
      changeHandler(val)
    },
    [changeHandler, onlyNumbers],
  )

  return (
    <>
      <Grid item xs={columns ? columns : 6} md={mdColumns ? mdColumns : columns ? columns : 6}>
        <TextField
          multiline={multiline}
          variant={variant ? variant : multiline ? 'outlined' : 'standard'}
          rows={multiline ? 4 : 1}
          inputProps={{ pattern: '[0-9]+([,][0-9]{1,2})?' }}
          onChange={onChange}
          disabled={displayOnly}
          type={inputType}
          value={value}
          fullWidth={true}
          label={shownLabel}
          required={required}
        />
      </Grid>
      {aloneInRow && <Grid item xs={6} />}
    </>
  )
}
